'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { createContext, useContext, useEffect, useState } from 'react';

import PropTypes from 'prop-types';

export const ThemeContext = createContext({
    theme: 'default',
    setTheme: null,
});

export const useTheme = () => {
    const { theme, setTheme } = useContext(ThemeContext);
    return [theme?.toLowerCase(), setTheme];
};

export const ThemeProvider = ({ theme: renderedTheme, children }) => {
    const [theme, setTheme] = useState(renderedTheme);

    useEffect(() => {
        setTheme(renderedTheme);
    }, [renderedTheme]);

    return (
        <ThemeContext.Provider value={{ theme, setTheme }}>
            {children}
        </ThemeContext.Provider>
    );
};

ThemeProvider.propTypes = {
    theme: PropTypes.string,
    children: PropTypes.oneOfType([
        PropTypes.object.isRequired,
        PropTypes.array.isRequired,
    ]),
};
